import { ClientCategoryDto } from "../../modules/Admin/ClientManagement/types";

/**
 * Kategoriler veritabanında; burada yalnızca ikon kataloğu ve gösterim yardımcıları var.
 * İkon seti sabit: her ikon `ui/icons.tsx` içinde inline SVG, bilinmeyen anahtar `mobile`e düşer.
 */
export type CategoryIconKey =
  | "document"
  | "shield"
  | "person"
  | "dashboard"
  | "flask"
  | "mobile";

export const CATEGORY_ICON_KEYS: CategoryIconKey[] = [
  "document",
  "shield",
  "person",
  "dashboard",
  "flask",
  "mobile",
];

export const FALLBACK_ICON: CategoryIconKey = "mobile";

/** Varsayılan ("Diğer") kategorinin sabit Id'si; backend seed'i ile aynı. */
export const DEFAULT_CATEGORY_ID = 1;

export function iconKeyOf(category?: ClientCategoryDto | null): CategoryIconKey {
  const key = category?.icon as CategoryIconKey | undefined;
  return key && CATEGORY_ICON_KEYS.indexOf(key) >= 0 ? key : FALLBACK_ICON;
}

/** Dil seçimine göre kategori adı; `openPortal.ts`'teki `getPortalName` ile aynı mantık. */
export function getCategoryName(
  category: ClientCategoryDto | undefined | null,
  language?: string
): string {
  if (!category) return "";
  return language?.startsWith("en") && category.name_EN
    ? category.name_EN
    : category.name;
}

export function findCategory(
  categories: ClientCategoryDto[],
  id: number | undefined | null
): ClientCategoryDto | undefined {
  if (id == null) return undefined;
  return categories.find((c) => c.id === id);
}

/** Seçilebilir kategoriler: pasifler forma, filtreye ve mega menüye girmez. */
export function activeCategories(
  categories: ClientCategoryDto[]
): ClientCategoryDto[] {
  return categories.filter((c) => c.isActive);
}
